export const instantAccessItems: string[] = [
  'All 6 volumes, complete and ready to print',
  '180+ drills and games with diagrams, timings and three difficulty levels',
  'A full pathway from U8 first sticks to U17 competitive play',
  'Session plans you can run without any lacrosse background',
  "Women's rules explained so you never feel exposed on the sideline again",
  'Unlimited printing for your whole club, forever',
  'No subscription, no renewal, no monthly fee',
]
